module.exports = "i.loading{color:grey}i.ok{color:green}i.error{color:red}\n"